import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface RotinaAnaliticaAdmin {
  id?: number;
  nome: string;
  tipo: string;
  objetivo?: string | null;
  entrada_esperada?: string | null;
  procedimento?: string | null;
  criterio_achado?: string | null;
  saida_esperada?: string | null;
  ativo?: boolean | null;
  created_at?: string | null;
}

@Injectable({ providedIn: 'root' })
export class RotinasAnaliticasService {
  private http = inject(HttpClient);
  private base = '/api/admin/rotinas-analiticas';

  listar() {
    return this.http.get<RotinaAnaliticaAdmin[]>(this.base);
  }

  criar(payload: RotinaAnaliticaAdmin) {
    return this.http.post<RotinaAnaliticaAdmin>(this.base, payload);
  }

  atualizar(id: number, payload: RotinaAnaliticaAdmin) {
    return this.http.put<RotinaAnaliticaAdmin>(`${this.base}/${id}`, payload);
  }

  excluir(id: number) {
    return this.http.delete(`${this.base}/${id}`);
  }

  ativar(id: number, ativo: boolean) {
    return this.http.patch(`${this.base}/${id}/ativar?ativo=${ativo}`, {});
  }
}
